import * as React from 'react';
import { MainLayout, Link } from 'view/common';
import { history } from 'store';
import cx from 'classnames';
import LOGO from 'assets/img/logo.svg';
import './style.scss';

type Props = {
};

type State = {
}

const LogoBlock = () => (
  <div className="header_logo_block">
    <Link to="/">
      <div className="header_logo">
        <div className="header_logo_row">
          <img src={LOGO} alt="logo" />
        </div>
        <div className="header_subline">Powered by MasterStream</div>
      </div>
    </Link>
  </div>
);

const HeaderLinkBlock = () => (
  <div className="header_link_block">
    {/* <Link to="https://mserp.com/">MasterStream</Link> */}
    {/*
    <Link to="https://www.bandwidthfinder.com/contact">Contact</Link>
    <Link to="https://www.bandwidthfinder.com/about">About</Link>
    <Link to="https://www.bandwidthfinder.com/pricing">Pricing</Link>
    */}
  </div>
);

const HeaderLogin = ({ history }) => (
  <button type="button" onClick={() => history.push('/welcome')}>Login</button>
);


class Header extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const isWelcome = history.location.pathname === '/welcome';
    const isLanding = history.location.pathname === '/';
    if (isLanding) return (<div />);
    return (
      <div className={cx('header_container', {
        header_container_isWelcome: isWelcome,
      })}
      >
        <MainLayout>
          <div className="header_row">
            <LogoBlock />
            <div className="header_row">
              <HeaderLinkBlock />
              <a
                style={{
                  color: 'white',
                  fontSize: '16px',
                }}
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.masterstreamerp.com/"
              >MasterStream
              </a>
              {isLanding && <HeaderLogin history={this.props.history} />}
            </div>
          </div>
        </MainLayout>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/view/screens/Header/Header.jsx